import { io, Socket } from "socket.io-client";

const socketEndpoint: string | undefined =
  process.env.REACT_APP_SOCKET_ENDPOINT;

if (!socketEndpoint) {
  console.error(
    "Socket endpoint is not defined. Please check your environment variables.",
  );
}

let SocketClient: Socket;

function getSocket(): Socket {
  if (!SocketClient) {
    const accessToken = localStorage.getItem("accessToken");

    SocketClient = io(socketEndpoint as string, {
      transports: ["websocket", "polling"],
      reconnection: true,
      auth: {
        token: accessToken || "",
      },
    });

    SocketClient.on("connect", () => {
      console.log("Connected to the socket server");
    });

    SocketClient.on("connect_error", (error: Error) => {
      // If auth fails, try reconnecting with fresh token
      if (
        error.message === "Authentication required" ||
        error.message === "Invalid or expired token"
      ) {
        const freshToken = localStorage.getItem("accessToken");
        if (freshToken) {
          SocketClient.auth = { token: freshToken };
          SocketClient.connect();
        }
      }
    });

    SocketClient.on("disconnect", (reason: string) => {
      console.log("Disconnected from the socket server:", reason);
    });
  }

  return SocketClient;
}

/**
 * Reconnect with a fresh token (call after login or token refresh)
 */
export function reconnectSocket(): void {
  const accessToken = localStorage.getItem("accessToken");
  if (SocketClient) {
    SocketClient.auth = { token: accessToken || "" };
    if (!SocketClient.connected) {
      SocketClient.connect();
    } else {
      SocketClient.disconnect();
      SocketClient.connect();
    }
  }
}

/**
 * Disconnect the socket (call on logout)
 */
export function disconnectSocket(): void {
  if (SocketClient.connected) {
    SocketClient.disconnect();
  }
}

export default getSocket();
